export const formatLeadStatus = (status) => {
  switch (status) {
    case 'IN_MANUAL_ANALYSIS':
      return 'Análise Manual'
    case 'PENDING_MANUAL_ANALYSIS':
      return 'Pendente de Análise'
  }
}
